// @flow

import { createMuiTheme } from '@material-ui/core/styles';
import { green, red } from '@material-ui/core/colors';

const themePalette = {
    primary: {
        light: '#219ace',
        main: '#219ace',
        dark: '#204d74'
    },
    secondary: {
        light: '#219ace',
        main: '#219ace',
        dark: '#219ace'
    },
    warning: {
        main: '#ffc071',
        dark: '#ffb25e'
    },
    error: {
        xLight: red[50],
        main: red[500],
        dark: red[700]
    },
    success: {
        xLight: green[50],
        main: green[500],
        dark: green[700]
    }
};

const themeFont = {
    fontFamily: ['"Ubuntu"', 'sans-serif'].join(',')
};

const linkOverrides = {
    root: {
        color: '#219ace'
    }
};

const DefaultTheme = createMuiTheme({
    palette: {
        ...themePalette
    },
    typography: {
        ...themeFont
    },
    overrides: {
        ...linkOverrides
    }
});

export default DefaultTheme;
